export default __webpack_public_path__ + "static/media/90s_bg_desktop.579e49aa.jpg";